<template>
  <div>
    <div>
      <CContainer>
        <h3 class="display-4 text-center">Join Class</h3>
        <h5 class="display-6 text-center">
          Let's join our class to improve your skill and gain knowledge
        </h5>

        <CCol sm="12" class="mt-5">
          <CCol sm="6">
            <CSelect
              :value.sync="selectedGrade"
              :options="gradeOptions"
              @change="FilterPackage()"
            />
          </CCol>
          <CRow class="p-3">
            <CCol
              sm="6"
              v-for="(item, index) in FilterPackages"
              v-bind:key="item.Id"
            >
              <CCard @click="GoToDetail(item.Id, item.ScheduleId)">
                <img :src="getPic(index)" style="max-width: 100%" />
                <br />
                <div class="p-3">
                  <h4>
                    <strong
                      style="
                        font-size: 1.75rem;
                        line-height: 2rem;
                        font-family: Source Sans Pro, Arial, sans-serif;
                        font-weight: 400;
                      "
                      class="ml-3 mr-3 mt-5"
                      >{{ item.Name }}
                    </strong>
                  </h4>
                  <!-- <h5 class="mt-2 ml-3"> {{ item.Description }} </h5> -->
                  <br />
                  <h6 class="mt-2 ml-3 small text-muted">
                    Date :

                  {{ item.DateTimeSchedule }}
                  </h6>
                  <h6 class="mt-2 ml-3 small text-muted">
                    Grade : {{ item.Grade }}
                  </h6>
                </div>
              </CCard>
            </CCol>
          </CRow>
        </CCol>
      </CContainer>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import backgroundBanner from "../assets/img/bgApps.jpg";
Vue.use(VuejsDialog);
import _ from "lodash";
import $ from "jquery";

export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      packages: [],
      SelectedPackage: "",
      PackageDescription: "",

      urlApp: [],
      FilterPackages: [],
      selectedGrade: "",
      gradeOptions: [],
    };
  },
  async mounted() {
    this.GetAllPackages();
  },
  computed: {
     CreationDate: {
      get: function () {
        return moment().format("DD-MM-YYYY");
      },
    },
    
  },
  methods: {
    async GetAllPackages() {
      return this.$API
        .get(this.$AllClassPackage)
        .then(
          function (response) {
            this.packages = response.data;
             

            this.FilterPackages = this.packages;
         

            var scheduleNames = _.uniq(_.map(response.data, "Grade"));
            scheduleNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });

            this.gradeOptions = scheduleNames;
            this.gradeOptions.unshift("SELECT GRADE");
            this.getPic(this.packages.filePath);
           
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    getPic(index) {
      return "https://pickiddo.com" + this.FilterPackages[index].filePath;
    },
    GoToDetail(Id,ScheduleId) {
      this.$router.push("/DetailJoinClass?id=" + Id + "&scheduleId=" + ScheduleId);
    },
    FilterPackage() {
      console.log("masuk");
       
      this.FilterPackages = this.packages;


      this.FilterPackages = _.filter(
        this.FilterPackages,
        (item) => item.Grade === this.selectedGrade
      );
      
    },
  },
};
</script>

